import { Link } from 'react-router-dom';
import backgroundSrc from "@/assets/images/login-background.svg";
import { FaceFrownIcon } from '@heroicons/react/24/solid';
import { useTranslation } from 'react-i18next';

const Error404 = () => {
    const { t } = useTranslation();
    return (
        <div
            className="min-h-screen flex flex-col items-center justify-center bg-cover bg-center px-4 sm:px-6"
            style={{ backgroundImage: `url(${backgroundSrc})` }}
        >
            <div className="relative z-10 bg-[#F1EDE7] shadow-md rounded-lg p-6 sm:p-8 md:p-10 w-full max-w-[90%] sm:max-w-[450px] md:max-w-[507px]">
                <div className="flex flex-col items-center">
                    <FaceFrownIcon className="h-20 w-20 text-gray-700 mb-4" />
                    <p className="text-center text-gray-800 text-lg mb-4">
                        {t("error.404.bodyText", "Page not found.")}
                    </p>
                    <Link to="/" className="text-blue-500 hover:underline">
                        {t("error.404.goHomeLink", "Go back to home.")}
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default Error404;
